import state from './moduleTenantPdfTemplateState.js'
import mutations from './moduleTenantPdfTemplateMutations.js'
import actions from './moduleTenantPdfTemplateActions.js'
import getters from './moduleTenantPdfTemplateGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

